import { useSTheme } from 'styles/theme'
import XColors from 'v2/styles/colors'

const USE_DATABASE_COLORS = false

export const useXTheme = function () {
    const theme = useSTheme()
    //TODO Donca FGI-2739
    document.documentElement.style.setProperty('--primary-color', USE_DATABASE_COLORS ? XColors.primaryColor : '')
    document.documentElement.style.setProperty(
        '--secondary-color',
        USE_DATABASE_COLORS ? theme.colors.secondaryColor : ''
    )
    document.documentElement.style.setProperty(
        '--tertiary-color',
        USE_DATABASE_COLORS ? theme.colors.tertiaryColor : ''
    )
    document.documentElement.style.setProperty('--hover-color', USE_DATABASE_COLORS ? theme.colors.hoverColor : '')
    document.documentElement.style.setProperty(
        '--background-color',
        USE_DATABASE_COLORS ? theme.colors.backgroundColor : ''
    )
    document.documentElement.style.setProperty('--purple-50', USE_DATABASE_COLORS ? theme.colors.purple50 : '')
    document.documentElement.style.setProperty('--button-bg', USE_DATABASE_COLORS ? theme.colors.buttonBg : '')
    document.documentElement.style.setProperty(
        '--language-active-color',
        USE_DATABASE_COLORS ? theme.colors.languageSwitcherActiveColor : ''
    )
    document.documentElement.style.setProperty(
        '--language-inactive-color',
        USE_DATABASE_COLORS ? theme.colors.languageSwitcherInactiveColor : ''
    )
}
